import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import {
  AboutTeleRad,
  Footer,
  Header,
  Services,
  WorkUs,
  Home,
  Consult,
  Partner,
  Contact,
  Faq,
  IpaBanner,
} from "./containers";
import {
  euForEng,
  euForSrb,
  inoFundEng,
  inoFundSrb,
  progPodEng,
  progPodSrb,
  serbGovEng,
  serbGovSrb,
  znakUsaglasenosti,
  logoKatapult
} from "./assets";
import { contentSerbian, contentEnglish, languages } from "./assets";
import ScrollToTop from "./utilities/scrollTop";
import "./app.css";

function App() {
  const [languageSelected, setLanguageSelected] = useState("eng");

  const languageSelect = (lang) => {
    setLanguageSelected(lang);
  };

  const activeLanguage = (lang) => {
    switch (lang) {
      case "srb":
        return contentSerbian;
      case "eng":
        return contentEnglish;
      default:
        return contentEnglish;
    }
  };

  const activeBanner = (lang) => {
    switch (lang) {
      case "srb":
        return [
          { imgSrc: znakUsaglasenosti, alt: "ISO 13485" },
          { address: "https://www.mfin.gov.rs/sr", imgSrc: serbGovSrb },
          { address: "http://www.inovacionifond.rs/lat/program/katapult", imgSrc: logoKatapult },
          {
            address:
              "https://www.euzatebe.rs/rs/projekti/programi-podrske-inovacijama-malih-i-srednjih-preduzeca",
            imgSrc: progPodSrb,
          },
          { address: "http://www.inovacionifond.rs/lat/", imgSrc: inoFundSrb },
          { address: "https://www.euzatebe.rs/", imgSrc: euForSrb },
        ];
      case "eng":
        return [
          { imgSrc: znakUsaglasenosti, alt: "ISO 13485" },
          { address: "https://www.mfin.gov.rs/en", imgSrc: serbGovEng },
          { address: "http://www.inovacionifond.rs/en/programs/katapult", imgSrc: logoKatapult },
          {
            address:
              "https://www.euzatebe.rs/en/projects/mini-and-matching-grants-programme",
            imgSrc: progPodEng,
          },
          { address: "http://www.inovacionifond.rs/en/", imgSrc: inoFundEng },
          { address: "https://www.euzatebe.rs/en/", imgSrc: euForEng },
        ];
      default:
        return [
          { imgSrc: znakUsaglasenosti, alt: "ISO 13485" },
          { address: "https://www.mfin.gov.rs/en", imgSrc: serbGovEng },
          { address: "http://www.inovacionifond.rs/en/programs/katapult", imgSrc: logoKatapult },
          {
            address:
              "https://www.euzatebe.rs/en/projects/mini-and-matching-grants-programme",
            imgSrc: progPodEng,
          },
          { address: "http://www.inovacionifond.rs/en/", imgSrc: inoFundEng },
          { address: "https://www.euzatebe.rs/en/", imgSrc: euForEng },
        ];
    }
  };

  const {
    navigation,
    opener,
    aboutUs,
    consult,
    bePartner,
    features,
    buttons,
    services,
    faq,
    contact,
    footerContent,
  } = activeLanguage(languageSelected);

  return (
    <BrowserRouter>
      <ScrollToTop>
        <div className="App">
          <Header
            linkList={navigation}
            languages={languages}
            languageSelect={languageSelect}
          />
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  slideContent={opener}
                  aboutContent={aboutUs}
                  consultContent={consult}
                  bePartnerContent={bePartner}
                  featuresContent={features}
                  buttons={buttons}
                />
              }
            />
            <Route
              path="workUs"
              element={<AboutTeleRad aboutContent={aboutUs} />}
            />
            <Route
              path="services"
              element={<Services servicesContent={services} />}
            />
            <Route
              path="consult"
              element={<Consult consultContent={consult} />}
            />
            <Route
              path="partner"
              element={
                <Partner
                  partnerContent={bePartner}
                  featuresContent={features}
                />
              }
            />
            <Route path="faq" element={<Faq faqContent={faq} />} />
            <Route
              path="contact"
              element={<Contact contactContent={contact} />}
            />
            {/* <Route path="news" element={<News />} /> */}
          </Routes>
          <WorkUs contactContent={contact} />
          <IpaBanner imgArray={activeBanner(languageSelected)} />
          <Footer footerContent={footerContent} />
        </div>
      </ScrollToTop>
    </BrowserRouter>
  );
}

export default App;
